import styled from '@common/theme/styled-components';

export const FormGroup = styled.div`
  &:not(:last-child) {
    margin-bottom: 20px;
    padding-bottom: 25px;
    border-bottom: 1px solid ${(props) => props.theme.brandBgColor};
  }
`;
